/* terminal/actions */
import { action } from "typesafe-actions";
import { HashedHotCard, HashedHotCardActionTypes, Data} from "./types";

export const fetchRequest = (
  id?: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(HashedHotCardActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (hashedHotCard: HashedHotCard) =>
  action(HashedHotCardActionTypes.FETCH_SUCCESS, hashedHotCard);

export const fetchError = (error: string) =>
  action(HashedHotCardActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: {id: string, data: Data},
  callback?: (err: string | null, data: HashedHotCard | null) => unknown
) => action(HashedHotCardActionTypes.SAVE_REQUEST, { data, callback});

export const saveSuccess = (data: Data) => {
  return action(HashedHotCardActionTypes.SAVE_SUCCESS, data);
}
export const saveError = (error: string) =>
  action(HashedHotCardActionTypes.SAVE_ERROR, error);